import { preload } from 'react-dom';

/**
 * PreloadResources component
 * 
 * Used to preload critical assets like images, fonts, or scripts for a specific page.
 * Uses ReactDOM.preload for better cross-environment support and hoisting.
 * 
 * @param {Object[]} resources - Array of resource objects to preload
 * @param {string} resources[].href - The URL of the resource
 * @param {string} resources[].as - The type of resource (image, font, script, style)
 * @param {Object} [resources[].options] - Additional options like type, crossOrigin, fetchPriority
 */
export default function PreloadResources({ resources }) {
    if (!resources || !Array.isArray(resources)) return null;

    resources.forEach((resource) => {
        if (resource.href && resource.as) {
            preload(resource.href, {
                as: resource.as,
                ...resource.options
            });
        }
    });

    return null;
}
